import { createFeatureSelector, createSelector } from '@ngrx/store';

import { getSelectedShippingMethod } from '../shipping/shipping.selectors';

import { PickupState } from './pickup.state';

import { DroppointListsDetail } from '@api/store-locator/droppoint-lists/models/droppoint-lists.models';
import { Address } from '@features/address';
import { ShippingMethod } from '@features/shipping';
import { getSelectedAddress } from '@shared/address/store/address/address.selectors';

const selectPickupState = createFeatureSelector<PickupState>('pickup');

export const getPickupPointMethodState = createSelector(selectPickupState, (state: PickupState) => state);
export const getPickupPointsStatus = createSelector(selectPickupState, (state: PickupState) => state.status);
export const getPickupPointsViewMode = createSelector(selectPickupState, (state: PickupState) => state?.selectedView);
export const getSearchedPickupPointsWithoutFilter = createSelector(selectPickupState, (state: PickupState) => state?.values);
export const getSearchedPickupPointsAmount = createSelector(
    selectPickupState,
    (state: PickupState) => state?.values?.length || 0
);
export const getStoreSearchRequestParameters = createSelector(
    getPickupPointMethodState,
    (state: PickupState) => state.searchRequestParameters
);
export const getSearchedPickupPoint = createSelector(
    getPickupPointMethodState,
    (state: PickupState) => state.searchRequestParameters
);
export const isReadyToPayment = createSelector(
    getSelectedShippingMethod,
    getSelectedAddress,
    (shippingMethod: ShippingMethod, selectedAddress: Address) => {
        if (shippingMethod?.id && selectedAddress?.id) return true;
        return false;
    }
);
export const getSelectedPickupPoint = createSelector(selectPickupState, (state: PickupState) => state?.selectedPickupPoint);
export const getSelectedDropPoint = createSelector(
    selectPickupState,
    (state: PickupState) => state?.selectedPickupPoint as DroppointListsDetail
);
export const isReadyToPaymentPickup = createSelector(getSelectedShippingMethod, getSearchedPickupPoint);
export const getPickupFilter = createSelector(selectPickupState, (state: PickupState) => state?.filter);

export const getPickupCapacityFeatureStatus = createSelector(
    selectPickupState,
    (state: PickupState) => state?.showPickUpCapacityFeature
);

export const getPickupCapacityFilterStatus = createSelector(
    selectPickupState,
    (state: PickupState) => state?.isPickUpCapacityFilterApplied
);

export const getPickupFreeDroppointFilter = createSelector(
    selectPickupState,
    (state: PickupState) => state?.freeDroppointFilter
);
